<template>
  <div class="rank-page">
    <img src="../assets/bg.png" class="rank-bg" alt="" />
    <div class="rank-mask">
      <div class="rank-head">
        <div class="rank-venue">{{ venueName || '本场大屏' }}</div>
        <div class="rank-title">{{ titleText }}</div>
        <div class="rank-sub">固定屏 · {{ refreshSec }}s 刷新 · {{ clock }}</div>
      </div>

      <div v-if="categories.length" class="rank-grid">
        <div v-for="cat in categories" :key="cat.play_type" class="cat-card">
          <div class="cat-name">{{ cat.play_type }}</div>
          <div
            v-for="row in cat.list"
            :key="row.user_id"
            class="cat-row"
            :class="'r' + row.rank"
          >
            <div class="cat-rank">{{ row.rank }}</div>
            <img class="cat-avatar" :src="row.avatar_url || defaultAvatar" alt="" />
            <div class="cat-nick">{{ row.nickname || '玩家' }}</div>
            <div class="cat-score">{{ row.score }}</div>
          </div>
          <div v-if="!cat.list.length" class="cat-empty">暂无上榜</div>
        </div>
      </div>
      <div v-else class="rank-empty">{{ emptyText }}</div>
    </div>
  </div>
</template>

<script>
import autofit from 'autofit.js'
import { boardPlayScoreRanks, getVenueInfo } from '@/api/team/index.js'

const PERIOD_TITLE = {
  week: '分类积分 · 周榜',
  month: '分类积分 · 月榜',
  quarter: '分类积分 · 季榜'
}

export default {
  name: 'RankScore',
  data() {
    return {
      venueId: 0,
      period: 'week',
      venueName: '',
      categories: [],
      clock: '',
      refreshSec: 20,
      timer: null,
      clockTimer: null,
      defaultAvatar: 'https://static.superyuwang.com/default/avatar.png',
      emptyText: '加载中…'
    }
  },
  computed: {
    titleText() {
      return PERIOD_TITLE[this.period] || PERIOD_TITLE.week
    }
  },
  created() {
    const q = this.$route.query || {}
    this.venueId = Number(q.venueId || q.venue_id || q.id || 0)
    const p = String(q.period || 'week').toLowerCase()
    this.period = ['week', 'month', 'quarter'].includes(p) ? p : 'week'
  },
  mounted() {
    autofit.init({ dh: 1080, dw: 1920, el: 'body', resize: true })
    this.tickClock()
    this.clockTimer = setInterval(this.tickClock, 1000)
    this.load()
    this.timer = setInterval(this.load, this.refreshSec * 1000)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
    if (this.clockTimer) clearInterval(this.clockTimer)
    try {
      autofit.off()
    } catch (e) {
      /* ignore */
    }
  },
  methods: {
    tickClock() {
      const d = new Date()
      const pad = (n) => (n < 10 ? `0${n}` : `${n}`)
      this.clock = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    async load() {
      if (!this.venueId) {
        this.emptyText = '缺少 venueId，请用管理端复制的固定链接打开'
        this.categories = []
        return
      }
      try {
        if (!this.venueName) {
          const { data: venue } = await getVenueInfo({ venue_id: this.venueId })
          this.venueName = (venue && venue.name) || ''
        }
      } catch (e) {
        /* ignore */
      }
      try {
        const { data } = await boardPlayScoreRanks({
          venue_id: this.venueId,
          period: this.period,
          limit: 10
        })
        const cats = (data && data.categories) || []
        this.categories = cats
        this.emptyText = cats.length ? '' : '本周期暂无积分 · 场管在小程序打分后会出现'
      } catch (e) {
        this.emptyText = '榜单加载失败，稍后自动重试'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rank-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  color: #fff;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}
.rank-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}
.rank-mask {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  height: 100%;
  padding: 36px 48px 48px;
  background: linear-gradient(180deg, rgba(8, 12, 28, 0.55), rgba(8, 12, 28, 0.82));
  display: flex;
  flex-direction: column;
}
.rank-head {
  display: flex;
  align-items: baseline;
  gap: 24px;
  margin-bottom: 28px;
}
.rank-venue {
  font-size: 28px;
  opacity: 0.85;
}
.rank-title {
  font-size: 48px;
  font-weight: 700;
  letter-spacing: 2px;
}
.rank-sub {
  margin-left: auto;
  font-size: 22px;
  opacity: 0.65;
}
.rank-grid {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));
  gap: 24px;
  overflow: auto;
}
.cat-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 20px 22px 12px;
}
.cat-name {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 14px;
  color: #7ec8ff;
}
.cat-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.cat-rank {
  width: 36px;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  opacity: 0.8;
}
.r1 .cat-rank {
  color: #ffd56a;
}
.r2 .cat-rank {
  color: #c9d6e8;
}
.r3 .cat-rank {
  color: #e0a57a;
}
.cat-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
  background: #222;
}
.cat-nick {
  flex: 1;
  font-size: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cat-score {
  font-size: 28px;
  font-weight: 700;
  color: #ffb347;
  min-width: 72px;
  text-align: right;
}
.cat-empty,
.rank-empty {
  font-size: 26px;
  opacity: 0.7;
  padding: 40px 8px;
  text-align: center;
}
.rank-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
